module.exports = __webpack_public_path__ + "static/item-9-38b6a11ed25d1ad54b95dd763555834f.jpeg";